import Addusers from './views/pages/appusers/Addusers'
import Appusers from './views/pages/appusers/Appusers'
import Showusers from './views/pages/appusers/Showusers'
import Adminusers from './views/pages/adminusers/Adminusers'
import Bankdetails from './views/pages/bankdetails/Bankdetails'
import Notification from './views/pages/notification/Notification'
import Dashboard from './views/dashboard/Dashboard'
import Editusers from './views/pages/appusers/Editusers'
import DeliveryCharges from './views/pages/masterdata/DeliveryCharges'
import Banner from './views/pages/masterdata/Banner'
import Coupons from './views/pages/masterdata/Coupons'
import Blogs from './views/pages/masterdata/Blogs'
import Categories from './views/pages/productdata/Categories'
import SubCategories from './views/pages/productdata/SubCategories'
import Products from './views/pages/productdata/Products'
import Allorders from './views/pages/orders/Allorders'
import OrdersHistory from './views/pages/orders/OrdersHistory'
import OrdersPending from './views/pages/orders/OrdersPending'
import OrdersCompleted from './views/pages/orders/OrdersCompleted'
import ShoppingCart from './views/pages/shoppingcart/ShoppingCart'
import AbandonedCart from './views/pages/shoppingcart/AbandonedCart'
import OrdersCancelled from './views/pages/orders/OrdersCancelled'
import SalesReports from './views/pages/salesreports/SalesReports'
import CustomerReports from './views/pages/customerreports/CustomerReports'
import TaxInvoice from './views/pages/settings/TaxInvoice'
import DeliveryBoys from './views/pages/deliveryboys/DeliveryBoys'
import AssignOrders from './views/pages/deliveryboys/AssignOrders'
import DeliveryHistory from './views/pages/deliveryboys/DeliveryHistory'
import Profile from './views/pages/profile/Profile'
import Navigation from './views/pages/navigation/Navigation'

const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/profile', name: 'Profile', element: Profile },
  { path: '/dashboard', name: 'Dashboard', element: Dashboard },
  { path: '/users/all', name: 'App users', element: Appusers },
  { path: '/users/new', name: 'Add users', element: Addusers },
  { path: '/users/:id', name: 'User Details', element: Showusers },
  { path: '/users/edit/:id', name: 'User Update', element: Editusers },
  { path: '/users/admin', name: 'Admin users', element: Adminusers },

  { path: '/delivery-boys/all', name: 'Delivery Boys', element: DeliveryBoys },
  { path: '/delivery-boys/assign-order', name: 'Assign Orders', element: AssignOrders },
  { path: '/delivery-boys/history', name: 'Delivery History', element: DeliveryHistory },

  { path: '/orders/all', name: 'All Orders', element: Allorders },
  { path: '/orders/history', name: 'Orders History', element: OrdersHistory },
  { path: '/orders/pending', name: 'Orders Pending', element: OrdersPending },
  { path: '/orders/completed', name: 'Orders Completed', element: OrdersCompleted },
  { path: '/orders/cancelled', name: 'Orders Cancelled', element: OrdersCancelled },

  { path: '/cart/shopping-cart', name: 'Shopping Cart', element: ShoppingCart },
  { path: '/cart/abandoned', name: 'Abandoned Cart', element: AbandonedCart },

  { path: '/reports/sales', name: 'Sales Reports', element: SalesReports },
  { path: '/reports/customers', name: 'Customer Reports', element: CustomerReports },
  { path: '/settings/tax-invoice', name: 'Tax & Invoice', element: TaxInvoice },
  { path: '/settings/navigation', name: 'Navigation', element: Navigation },

  { path: '/payment/details', name: 'Bank Details', element: Bankdetails },
  { path: '/master/banner', name: 'Banner', element: Banner },
  { path: '/master/blogs', name: 'Blogs', element: Blogs },
  { path: '/master/coupons', name: 'Coupons', element: Coupons },
  { path: '/master/delivery-charges', name: 'Delivery Charges', element: DeliveryCharges },
  { path: '/product/categories', name: 'Categories', element: Categories },
  { path: '/product/sub-categories', name: 'Sub Categories', element: SubCategories },
  { path: '/product/products', name: 'Products', element: Products },
  { path: '/notification', name: 'Notification', element: Notification },
]

export default routes
